import React, { useEffect } from 'react';
import { getDomainSettings } from '../utils/domainUtils';

/**
 * This component updates the page metadata (title, description, keywords)
 * based on the current domain. It's essential for pre-rendering with React Snap
 * to ensure correct metadata for SEO.
 */
const MetaUpdater: React.FC = () => {
  useEffect(() => {
    // Get domain-specific settings
    const { title, description, keywords } = getDomainSettings();
    
    // Update document title
    document.title = title;
    
    // Update meta tags
    const titleMeta = document.getElementById('title-meta');
    const descriptionMeta = document.getElementById('description-meta');
    const keywordsMeta = document.getElementById('keywords-meta');
    
    if (titleMeta) {
      titleMeta.setAttribute('content', title);
    }
    
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', description);
    }
    
    if (keywordsMeta) {
      keywordsMeta.setAttribute('content', keywords);
    }
  }, []);
  
  // This component doesn't render anything
  return null;
};

export default MetaUpdater; 